<template>
    <div>
        <b-button variant="success" @click.stop="abrirModal()">
            <span>
                <i class="fa fa-plus mr-2"></i> Inserir Metas
            </span>
        </b-button>
        <evento-form :mostrarModal="mostrarModal" :erros="erros" :acao="acao" @fechar="fecharModal()"
            @salvar="inserirMeta($event)"></evento-form>
    </div>
</template>

<script>
import EventoForm from './EventoForm'

export default {
    props: {
        acao: {
            type: Object,
            default: () => ({})
        },

        dataServicos: {
            type: Object
        },
    },

    components: {
        EventoForm
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        inserirMeta(meta) {
            this.$store.dispatch('addRequest')
            if (meta.tipoDaMeta == 1) {
                let eventoDto = {
                    codEvento: meta.codEvento,
                    nomeEvento: meta.nomeEvento,
                    idAcaoPlanoTrabalho: meta.idAcaoPlanoTrabalho,
                }

                this.dataServicos.inserirEvento(eventoDto)
                    .then(response => {
                        if (response) {
                            if (response.success) {
                                this.$toast.success(
                                    'Evento inserido com sucesso',
                                    'OK',
                                    this.$toastConfig.success)
                                this.$emit('atualizarListaEventos')
                            } else {
                                this.$emit('atualizarErros', response.errors);
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    })
                this.fecharModal()
            }

            if (meta.tipoDaMeta == 0) {

                let consultoriaDto = {

                    nomeConsultoria: meta.nomeConsultoria,
                    totalPrevisto: meta.totalPrevisto,
                    totalRealizado: meta.totalRealizado,
                    idAcaoPlanoTrabalho: meta.idAcaoPlanoTrabalho,
                    idConvenio: meta.idConvenio

                }

                this.dataServicos.inserirConsultoria(consultoriaDto)
                    .then(response => {
                        if (response) {

                            if (response.success) {
                                this.$toast.success(
                                    'Consultoria inserida com sucesso',
                                    'OK',
                                    this.$toastConfig.success)
                                this.$emit('atualizarListaConsultorias')
                            } else {
                                this.$emit('atualizarErros', response.errors);
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    })
                this.fecharModal()

            }
            if (meta.tipoDaMeta == 2) {

                let entregaDto = {

                    nomeEntrega: meta.nomeEntrega,
                    totalPrevisto: meta.totalPrevisto,
                    totalRealizado:0,
                    idAcaoPlanoTrabalho: meta.idAcaoPlanoTrabalho,
                    idConvenio: meta.idConvenio
                }
                this.dataServicos.inserirEntrega(entregaDto)
                    .then(response => {
                        if (response) {

                            if (response.success) {
                                this.$toast.success(
                                    'Entrega inserida com sucesso',
                                    'OK',
                                    this.$toastConfig.success)
                                this.$emit('atualizarListaEntregas')
                            } else {
                                this.$emit('atualizarErros', response.errors);
                                this.erros = response.errors
                            }
                        }
                        this.$store.dispatch('removeRequest')
                    })
                this.fecharModal()
                }
        },
    },
}
</script>
